var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListView',{attrs:{"items":_vm.capabilities,"showIndex":true},on:{"selected":_vm.onSelectedCapability}})}
var staticRenderFns = []

export { render, staticRenderFns }